/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_4_DescInputs */

const en_mk_sec_4_desc = /** @type {(inputs: Mk_Sec_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipping evidence needs a written reason; it shows on the task card, the public page and the audit export. No silent “done”.`)
};

const id_mk_sec_4_desc = /** @type {(inputs: Mk_Sec_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melewati bukti butuh alasan tertulis; tampil di kartu task, halaman publik, dan ekspor audit. Tidak ada “selesai” diam-diam.`)
};

/**
* | output |
* | --- |
* | "Skipping evidence needs a written reason; it shows on the task card, the public page and the audit export. No silent “done”." |
*
* @param {Mk_Sec_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_4_desc = /** @type {((inputs?: Mk_Sec_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_4_desc(inputs)
	return en_mk_sec_4_desc(inputs)
});